import React, { useEffect, useMemo } from 'react';
import { Button, Card, Skeleton, Typography, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { LoadingOutlined } from '@ant-design/icons';
import moment from 'moment';

export default function BasicSettings({ loading, data = {}, onChangeMode }) {
  const { t } = useTranslation();

  const dateStr = useMemo(() => {
    return data.expire ? moment(data.expire).format('L LT') : '-';
  }, [data]);

  const daysStr = useMemo(() => {
    return data.expire ? moment().to(data.expire) : '-';
  }, [data]);

  return (
    <Card className="settings-card" title={t('license')} bordered={false}>
      <Space direction="vertical" size="middle">
        {loading ? (
          <Skeleton.Input style={{ width: 300 }} active size="small" />
        ) : (
          <Typography.Text>
            {data.trial ? t('trial') : t('permanent')}{' '}
            {t('expireText', { date: dateStr })}{' '}
            <Typography.Text type="danger">({daysStr})</Typography.Text>
          </Typography.Text>
        )}
        <Button onClick={onChangeMode} disabled={loading}>
          {t('change-license')}
        </Button>
      </Space>
    </Card>
  );
}
